import React, { Suspense, useLayoutEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useProfile } from '@/entities/profile';
import { LanguageSwitcher } from '@/features/accountSettings';
import { Box } from '@/shared/ui';
import { Loader, useLoader } from '@/shared/ui/Loader';
import { Logo } from '@/shared/ui/Logo';
import { getRoutePath } from '@/shared/utils/routes';

import { StyledAuthLayout, StyledLogoContainer } from './styles';

export const AuthLayout = () => {
  const { profile, isLoading } = useProfile();
  const { isShowLoader } = useLoader();

  useLayoutEffect(() => {
    isShowLoader(isLoading);
    return () => {
      isShowLoader(false);
    };
  }, [isLoading, isShowLoader]);

  if (profile) {
    return <Navigate to={getRoutePath('MAIN', 'INDEX')} replace />;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        minHeight: '100vh',
        width: '100vw',
        bgcolor: 'background.default',
      }}
    >
      <StyledAuthLayout>
        <StyledLogoContainer>
          <Logo variant="secondary-dark" />
          <Box
            maxWidth={300}
            sx={{
              '& .MuiInputBase-root': { backgroundColor: 'transparent' },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(255,255,255,0.3)',
              },
              '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline':
                { borderColor: 'rgba(255,255,255,0.6)' },
              '& .MuiSelect-select': { color: 'white' },
              '& .MuiSvgIcon-root': { color: 'white' },
            }}
          >
            <LanguageSwitcher isAuthPage />
          </Box>
        </StyledLogoContainer>

        <Box
          sx={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <Suspense fallback={<Loader containerSize="large" />}>
            <Outlet />
          </Suspense>
        </Box>
      </StyledAuthLayout>
    </Box>
  );
};
